'use client';

import { useQuery } from '@tanstack/react-query';
import OnboardingApi from '@/repositories/onboarding';

/**
 * URLs of the legal documents the onboarding forms link to.
 *
 * Failures are swallowed on purpose: the documents are supporting links, so a
 * missing one must never block the form or raise a toast. The anchors fall back
 * to plain text when the URL is unavailable.
 */
export function useTerms() {
  const { data, isFetching } = useQuery({
    queryKey: ['onboarding-terms'],
    queryFn: async () => {
      try {
        return await OnboardingApi.getTerms();
      } catch {
        return null;
      }
    },
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
  });

  return {
    termsOfUseUrl: data?.termsOfUse ?? null,
    privacyPolicyUrl: data?.privacyPolicy ?? null,
    isLoading: isFetching,
  };
}
